import { React, useState, useEffect } from 'react'
import "./header.css"
import { Link, useNavigate } from 'react-router-dom';
import Avatar from "../../Asserts/images/avatar.png"

const IntegrationHeader = () => {

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const user = JSON.parse(localStorage.getItem('user'));
    const navigate = useNavigate()
    
    const toggleDropdown = () => {
        setIsDropdownOpen((prev) => !prev); // Toggle dropdown state
    };

    const handleOut = () => {
        localStorage.clear();
        window.location.href = '/';
    };
    
    return (
        <nav class="navbar-expand-lg  invHead ">
            <div class="container-fluid">
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse d-flex end gap-4" id="navbarSupportedContent">
                    <h5 className='col-2 bold m-0'>Member Management</h5>
                    <div className="col-4"></div>
                    <div className="col-3"></div>
                    <div className="d-flex gap-2">
                        <div className="invprofileimg">
                            <img src={Avatar} className="Invboxicon" alt="Avatar" />
                        </div>
                        <div className="InvProfile dropdown">
                            <div onClick={toggleDropdown} className="dropdown-toggle">
                                {user?.FirstName + "  " + user?.LastName || "No-User"}
                            </div>
                            {isDropdownOpen && (
                                <div className="dropdown-content-stats pt-1">
                                    {/* <Link to="/admin/Setting/Profile" className="p-2">Setting</Link> */}
                                    <Link onClick={handleOut} className="p-2">Log Out</Link>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    )
}

export default IntegrationHeader;